<template>
  <v-app>
    <v-app-bar app
               clipped-left
               dark
               flat
               color="primary"
               class="d-print-none"
    >

      <v-app-bar-nav-icon v-if="!drawer" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="d-flex justify-start align-center">

        <a href="/" style="max-width: 230px; max-height: 60px;">
          <v-img v-if="logo"
                 :src="logo"
                 height="100%"
                 max-height="60"
                 contain>
          </v-img>
        </a>

<!--        <v-divider vertical
                    class="mx-3">
        </v-divider>

        <v-toolbar-title class="mx-3">M2H</v-toolbar-title>-->
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex justify-end align-center">
        <m2h-locale-changer :active-page="activePage" :current-user="auth.user"></m2h-locale-changer>
<!--        <v-btn v-if="!auth.user" href="/logout" tile text>
          Logout
        </v-btn>-->
      </div>
    </v-app-bar>

    <v-main>
      <m2h-loader></m2h-loader>
<!--      <v-container fluid class="pa-0">
        <v-img src="/assets/img/header_small.png"
               height="100%"
               width="100%"
               contain>
        </v-img>
      </v-container>-->
      <slot></slot>
    </v-main>
    <v-footer
        inset
        app
        class="d-flex justify-center align-center"
    >
      <div class="text-center">&copy; {{ new Date().getFullYear() }} - <a href="https://movetohappiness.com/" target="_blank" class="text-decoration-none">Move To Happiness</a></div>
    </v-footer>
  </v-app>
</template>

<script>
  import i18n from "@/services/i18n";
  import api from "@/api/api";
  export default {
    i18n: i18n,
    name: "m2h-layout",
    props: ['siteId', 'title', 'activePage', 'user', 'siteName'],

    data() {
      return {
        companyBrandingTheme: null,
        miniVariant: true,
        drawer: true,
        auth: {
          user: null,
        },
        manageUserAccess: false,
        logo: ''
      }
    },

    mounted() {
      let miniVariant = localStorage.getItem('M2H.Portal.miniVariant')
      if (miniVariant === 'false'){ this.miniVariant = false }
      if (this.user){
        this.auth.user = JSON.parse(this.user)
        this.checkCompanyBranding()
      } else {
        this.logo = '/assets/img/logo_wit.png'
      }
    },

    methods:{
      async checkCompanyBranding(){
        if (this.auth.user.subOrganization && this.auth.user.subOrganization.metaData && this.auth.user.subOrganization.metaData.companyBrandingTheme) {
          this.companyBrandingTheme = this.auth.user.subOrganization.metaData.themes.light
        }
        else if (this.auth.user.organization.metaData.companyBrandingTheme){
          this.companyBrandingTheme = this.auth.user.organization.metaData.themes.light
        }
        if (this.companyBrandingTheme) {
          this.$vuetify.theme.currentTheme.primary = this.companyBrandingTheme.primary
          this.$vuetify.theme.currentTheme.secondary = this.companyBrandingTheme.secondary
          this.$vuetify.theme.currentTheme.accent = this.companyBrandingTheme.accent
          this.$vuetify.theme.currentTheme.error = this.companyBrandingTheme.error
          this.$vuetify.theme.currentTheme.info = this.companyBrandingTheme.info
          this.$vuetify.theme.currentTheme.success = this.companyBrandingTheme.success
          this.$vuetify.theme.currentTheme.warning = this.companyBrandingTheme.warning
        }
        
        if (this.auth.user.organization.metaData.companyBrandingLogo){
          let logoUrl = await this.fetchImage(this.auth.user.organization.metaData.logoId)
          this.logo = logoUrl
        } else {
          this.logo = '/assets/img/logo_wit.png'
        }
      },
      
      loadSite(siteId) {
        this.$root.$emit('m2h-loader-show')
        window.location.href= `/?siteId=${siteId}`
      },
      navigate(route){
        this.$root.$emit('m2h-loader-show')
        window.location.href = route
      },
      toggleMiniVariant(){
        this.miniVariant = !this.miniVariant
        localStorage.setItem('M2H.Portal.miniVariant', this.miniVariant)
      },
      async fetchImage(id){
        if (id){
          return await api.media.getOrganizationlogosSas(id)
              .then((res) => {
                return res.data
              })
              .catch(() => {
                return ''
              })
        } else {
          return ''
        }
      },
    }
  };
</script>

<style lang="scss">

  .v-application {
    font-family:  'Poppins', sans-serif !important;
  }
  .v-main {
    background-color: #F4F6F9;
  }
  /*.v-list-item__title {
    color: #0D47A1;
  }*/

  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 35px !important;
  }

  .v-dialog--fullscreen {
    border-radius: 0 !important;
    margin: 0 !important;
    height: calc(100% - 65px) !important;
    position: fixed;
    overflow-y: auto;
    top: 65px !important;
    left: 0 !important;
  }

</style>
